import { EntityBase } from "./entityBase";
import { Option } from "./option";

export class TypeOption extends EntityBase {
    public Name: string;
    public IsColor: boolean;

    public Options: Array<Option>;
}